import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  marketplaces: {
    description: 'customersGrid.columns.marketplaces',
    defaultMessage: 'Marketplace(s)',
    id: 'iWXKyT',
  },
  city: {
    description: 'customersGrid.columns.city',
    defaultMessage: 'City',
    id: 'PEfggx',
  },
  company: {
    description: 'customersGrid.columns.company',
    defaultMessage: 'Company',
    id: '2uU9qU',
  },
  country: {
    description: 'customersGrid.columns.country',
    defaultMessage: 'Country',
    id: '4LHnee',
  },
  email: {
    description: 'customersGrid.columns.email',
    defaultMessage: 'Email',
    id: '89W4aE',
  },
  name: {
    description: 'customersGrid.columns.name',
    defaultMessage: 'Name',
    id: 'gHU+5m',
  },
  phone: {
    description: 'customersGrid.columns.phone',
    defaultMessage: 'Phone',
    id: '6FY/jR',
  },
  state: {
    description: 'customersGrid.columns.state',
    defaultMessage: 'State',
    id: '+igQtH',
  },
  tags: {
    description: 'customersGrid.columns.tags',
    defaultMessage: 'Tags',
    id: '+QB7E4',
  },
  marketplaceUsernames: {
    description: 'customersGrid.columns.marketplaceUsernames',
    defaultMessage: 'Marketplace Username(s)',
    id: 'G/PljP',
  },
});
